import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { QueryParams0303DTO, QuestionDTO, QuestionDTOSchema } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "./api/http-format-interceptor.service";

@Injectable({
  providedIn: "root"
})
export class QuestionnaireService {
  private readonly http = inject(HttpClient);
  private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, QuestionDTOSchema);

  /**
   * récupère la première question du questionnaire
   * @returns première question
   */
  getFirstQuestion(dateEffet: string, montantEpargne: number): Observable<QuestionDTO> {
    const msParams: QueryParams0303DTO = {
      premiereQuestion: true,
      dateEffet,
      montantEpargne
    };
    return this.http.get<QuestionDTO>(environment.urlsMs.MS0303, {
      context: this.context,
      params: msParams
    });
  }

  /**
   * récupère la question suivante en fonction des code question et code réponse précédents
   * @param codeQuestionPrecedente code question
   * @param codeReponsePrecedente code réponse
   * @returns question
   */
  getNextQuestion(
    codeQuestionPrecedente: string,
    codeReponsePrecedente: string,
    dateEffet: string,
    montantEpargne: number
  ): Observable<QuestionDTO> {
    const msParams: QueryParams0303DTO = {
      dateEffet,
      questionPrecedente: codeQuestionPrecedente,
      reponsePrecedente: codeReponsePrecedente,
      montantEpargne
    };
    return this.http.get<QuestionDTO>(environment.urlsMs.MS0303, { context: this.context, params: msParams });
  }
}
